/**
 * Runtime configuration from Vite env (VITE_* only — nothing secret lives here; the client id and
 * scope are public identifiers for a PKCE SPA).
 */
export const DEFAULT_TENANT_ID = '9410a458-1981-47e6-a429-3aac490a78f1';

export interface ClientConfig {
  clientId: string;
  tenantId: string;
  apiScope: string;
  /** Canonical public URL, used for links people copy and Oracle deep links. */
  appBaseUrl: string;
  /** Origin this page was served from; MSAL redirects come back here. */
  origin: string;
  /** True when the client id is missing: auth is not configured, show a helpful banner. */
  authConfigured: boolean;
}

function readEnv(name: keyof ImportMetaEnv): string | undefined {
  const value = import.meta.env[name];
  return typeof value === 'string' && value.trim().length > 0 ? value.trim() : undefined;
}

export function loadConfig(): ClientConfig {
  const clientId = readEnv('VITE_ENTRA_CLIENT_ID') ?? '';
  const tenantId = readEnv('VITE_ENTRA_TENANT_ID') ?? DEFAULT_TENANT_ID;
  const apiScope = readEnv('VITE_API_SCOPE') ?? (clientId ? `api://${clientId}/access_as_user` : '');
  const origin = typeof window !== 'undefined' ? window.location.origin : 'http://localhost:5173';
  const appBaseUrl = (readEnv('VITE_APP_BASE_URL') ?? origin).replace(/\/+$/, '');
  return { clientId, tenantId, apiScope, appBaseUrl, origin, authConfigured: clientId.length > 0 };
}

export const config: ClientConfig = loadConfig();
